export default __webpack_public_path__ + "static/b-150-bug-06f729e6eb8c538ecfed336b2cb7fcef.png";